<template>
  <div style="background-color: #F9F9F9; height: 100vh;" @click="focusedInput">
    <loading v-model:active="pageLoader" :can-cancel="false" loader="dots" color="#02C782" background-color="#818585"
      width="130" height="130" :is-full-page="true" />
    <div class="mx-5  relative  ">
      <div class="flex flex-wrap justify-between mt-20 md:mt-0 items-baseline	">
        <h1 style="font-weight: 550;" class="text-2xl  mb-5 mt-10 ">New Disposal Entry
        </h1>
      </div>

      <div class="qr-code-input flex-wrap flex justify-between mb-5 md:mb-0 ">
        <input ref="focusedInputField" @paste="handlePaste" type="text" id="qrInput"
          class="rounded-lg md:ml-5 md:mb-0 mb-5 h-10" :class="{ 'disabled-input': isRequestPending }"
          :disabled="isRequestPending" v-model="qrCode" @input="handleInputChange" placeholder="Scan QR code" autofocus />
        <div class="flex flex-wrap w-full md:w-80 items-baseline" v-if="hasimportexceldispole">
          <label class="block w-[150px]  text-sm text-bg-save font-medium  text-[17px] dark:text-white"
            for="file_input">Upload
            Excel</label>
          <input @change="handleFileUpload"
            class="block w-full  text-sm md:mx-0 mx-4 text-gray-900 border mb-1 border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
            aria-describedby="file_input_help" id="file_input" type="file">
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-300" id="file_input_help"></p>
          <a style="cursor: pointer;" class="text-[#1C64F2] pt-1  underline text-xs  " @click="downloadFile">Download Template</a>

        </div>
      </div>
      <div class="relative overflow-x-auto overflow-hidden shadow-md mt-5">

        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-xs border-collapse text-gray-700  bg-stone-300		 dark:bg-gray-900 dark:text-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 border">
                QR Code
              </th>
              <th scope="col" class="px-6 py-3 border">
                <div class="flex items-center">
                  Collected At
                </div>
              </th>
              <th scope="col" class="px-6 py-3 border">
                <div class="flex items-center">
                  City
                  <a href="#"></a>
                </div>
              </th>
              <th scope="col" class="px-6 py-3 border">
                <div class=" flex items-center">
                  Hospital
                </div>
              </th>
              <th scope="col" class="px-6 py-3 border">
                <div class="flex items-center">
                  Collector's Team
                </div>
              </th>
              <!-- <th scope="col" class="px-6 py-3 border">
                <div class="flex items-center">
                  Helper
                </div>
              </th> -->
              <th scope="col" class="px-6 py-3 border">
                <div class="flex items-center">
                  WT (kg)
                </div>
              </th>
              <th scope="col" class="px-2 py-3 border">
                <div class="flex items-center">
                  Waste Handler
                </div>
              </th>
              <th scope="col" class="px-6 py-3 border">
                <div class="flex items-center">
                  Manager
                </div>
              </th>
            </tr>
          </thead>
          <tbody v-if="tabledata.length > 0">
            <tr v-for="scan in tabledata" :key="scan"
              class="bg-white border-b border dark:bg-gray-800 dark:border-gray-700">
              <td class="px-6 py-1 border">{{ scan?.qr_code }}</td>
              <td class="px-2 py-1 border">{{ scan?.collected_at }}</td>
              <td class="px-6 py-1 border">{{ scan?.district?.name }}</td>
              <td class="px-6 py-1 border">{{ scan?.hospital?.name }}</td>
              <td class="px-1 py-1 border">
                <div class="tooltip">{{ scan?.team }}
                  <span class="tooltiptext">{{ scan?.collectors_name }}</span>
                </div>
              </td>
              <!-- <td class="px-6 py-1 border">{{ scan?.helper?.name }}</td> -->
              <td class="px-6 py-1 border"> {{ scan?.weight ? `${scan?.weight}` : '' }}</td>
              <td class="px-6 py-1 border">{{ scan?.handler?.name }}</td>
              <td class="px-6 py-1 border">{{ scan?.dist_manager }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4 text-base text text-gray-900">No Data found!</td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
              <td class="px-6 py-4"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex mt-10 justify-end">
        <router-link to="" @click="cancelbtn" style="cursor: pointer;"
          class="text-white bg-button-blue hover:bg-hover-blue focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
          Back
        </router-link>

        &nbsp;
        <router-link to="" @click="saveqrcode" style="cursor: pointer;"
          class="text-white bg-bg-save hover:bg-hover-save ml-5 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-regal-blue dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
          Save
        </router-link>

      </div>
    </div>
  </div>
</template>



<script setup>
import { ref, watch, computed, onMounted, onUnmounted, onUpdated, onBeforeMount } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { useScanCodeStore } from '@/store/QRScanCode';
import Swal from 'sweetalert2';
// const qrscancode = useScanCodeStore();
const qrCode = ref();
const scannedCodes = ref([]);
import axiosInstance from "@/plugins/axios"
// const tabledata = computed(() => qrscancode.getIncineration)
const tabledata = ref([])
const pageLoader = ref(false);
const isRequestPending = ref(false)
import { useRouter } from 'vue-router';
const router = useRouter(); // Initialize the router object
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const handleFileUpload = (event) => {
  const file = event.target.files[0];
  uploadFile(file);
};

const uploadFile = async (file) => {
  pageLoader.value = true;
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosInstance.post('/incinerations/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    pageLoader.value = false;

    Swal.fire({
      icon: 'success',
      title: 'Collections disposed successfully',
      text: response.data.message
    });
    router.push({ name: 'incinerationConsole' });

    // Handle success (e.g., show a success message)
  } catch (error) {
    pageLoader.value = false;
    Swal.fire({
      icon: 'warning',
      title: 'Collections disposal failed',
      text: error.response.data.message
    });
  }
  focusedInput();
};

const handleInputChange = debounce(async () => {
  const qrCodeValue = qrCode.value;
  // console.log(qrCode.value)
  if (qrCodeValue.length === 24) {
    if (scannedCodes.value.includes(qrCodeValue)) {
      // If the QR code is already scanned, don't proceed
      qrCode.value = '';
      // scannedCodes.value = ''
      Swal.fire({
        icon: 'warning',
        title: 'QR code scanning failed',
        text: 'This QR Code is already scanned'
      });
      // Clear the input field
      return;
    }
    // scannedCodes.value.push(qrCodeValue);
    const payload = {
      qr_code: qrCodeValue
    };
    isRequestPending.value = true;
    try {
      if (scannedCodes.value.length === 10) {
        Swal.fire({
          icon: 'warning',
          title: 'Maximum scans reached',
          text: 'Prior to making additional entries, please save your progress first..'
        });
        return
      }
      const response = await axiosInstance.post("/incinerations/scan-qr-code", payload)
      tabledata.value.push(response.data.data)
      scannedCodes.value.push(qrCodeValue);
      qrCode.value = '';
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        console.error('QR code scanning failed:', error.response.data.message);
        isRequestPending.value = true;
        Swal.fire({
          icon: 'warning',
          title: 'QR code scanning failed',
          text: error.response.data.message
        }).then((result) => {
          if (result.isConfirmed) {
            isRequestPending.value = false;
            focusedInputField.value.focus();
          }
        });
        // scannedCodes.value = [];
      } else {
        qrCode.value = '';
        scannedCodes.value = [];
        console.error('QR code scanning failed:', error);
        // Show a generic error message if no specific message is available
        isRequestPending.value = true;
        Swal.fire({
          icon: 'warning',
          title: 'QR code scanning failed',
          text: 'Something went wrong while scanning the QR code.'

        }).then((result) => {
          if (result.isConfirmed) {
            isRequestPending.value = false;
            focusedInputField.value.focus();
          }
        });
      }
    } finally {
      focusedInput();
      isRequestPending.value = false; // Reset the flag after request completion or error
      qrCode.value = '';
    }
  } else {
    qrCode.value = '';
    // scannedCodes.value = []
    // tabledata.value = []
    isRequestPending.value = true;
    Swal.fire({
      icon: 'error',
      title: 'Incorrect QR code',
      // text: error.response.data.message
    }).then((result) => {
      if (result.isConfirmed) {
        isRequestPending.value = false;
      }
    });
  }
  focusedInput();
}, 500)
function downloadFile() {
      const downloadLink = "http://13.50.122.252:8080/import-templates/disposal_import_template.xlsx";
      window.open(downloadLink, "_blank");
    }
const focusedInputField = ref(null);

onMounted(() => {
  focusedInput();
})
onUpdated(() => {
  focusedInput();
})

const focusedInput = () => {
  if (focusedInputField.value) {
    focusedInputField.value.focus();
  }
};


onUnmounted(() => {
  tabledata.value = [];
  scannedCodes.value = [];
})
const cancelbtn = () => {
  tabledata.value = [];
  scannedCodes.value = [];
  router.push({ name: 'incinerationConsole' });

}

const saveqrcode = async () => {
  const payload = {
    qr_codes: scannedCodes.value
  };
  // console.log("Input value:", scannedCodes);
  if (scannedCodes.value.length > 0) {
    try {
      const response = await axiosInstance.post("/incinerations", payload);

      tabledata.value = [];
      Swal.fire({
        toast: true,
        title: 'Collections disposed successfully.',
        icon: 'success',
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
      tabledata.value = [];
      scannedCodes.value = [];
      // Redirect to another route using Vue Router
      router.push({ name: 'incinerationConsole' });

    } catch (error) {
      focusedInput();
      console.error('Error saving QR codes:', error);
      scannedCodes.value = [];
      tabledata.value = []
      // Show an error message to the user
      Swal.fire({
        icon: 'error',
        title: 'Saving QR codes failed',
        text: error.response.data.message ?? 'Saving QR codes failed.'
      });
    }
  } else {
    Swal.fire({
      icon: 'error',
      title: 'please scan QR codes',
      text: 'please scan QR codes.'
    });
  }
};
import { useAuthService } from '@/store/Auth'; //  auth.js file
const authStore = useAuthService();
const permissions = ref([])
onMounted(() => {
  permissions.value = authStore.authData.permissions

});
const hasimportexceldispole = computed(() => permissions.value.some(permission => permission.name === 'can dispose collections from excel'));
const handleLogin = async () => {
  try {
    const response = await axiosInstance.get('/is-user-login');
    // console.log(response.data);
    if (response?.data && response?.data?.data && response?.data?.data?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('authService');
      router.push({ name: 'Login' });
    }
  } catch (error) {
    console.log('Error Response:', error.response.status);
    if (error?.response?.status === 500) {
      // Handle the specific exception, for example, log it
      // console.error('SessionExpireTimeMiddleware exception:', error?.response?.status);
      // Redirect to login or handle as needed
      localStorage.removeItem('token');
      localStorage.removeItem('authService');
      router && router.push({ name: 'Login' });
    }
    if (error?.response && error?.response && error?.response?.status !== 200) {
      localStorage.removeItem('token');
      localStorage.removeItem('authService');
      router.push({ name: 'Login' });
    }
  }
};
onBeforeMount(async () => {
  handleLogin()
  await authStore.handlepermission()
})
// Inside the <script setup> section
const handlePaste = (event) => {
  event.preventDefault();
  const clipboardData = event.clipboardData || window.clipboardData;
  const pastedText = clipboardData.getData('text');
  // Handle pastedText as needed
  // For example, you can ignore pasting or show a warning to the user
  console.log('Pasted text:', pastedText);
  Swal.fire({
    icon: 'warning',
    title: 'Pasting is not allowed',
    text: 'Please scan the QR code using scanner.'
  });
};

// ... your other code


onUnmounted(async () => {
  await authStore.handlepermission()
})
</script>


<style scoped>
/* .disabled-input {
    border: 1px solid red;
    color: red;
}

.disabled-save {
    background: darkgrey;
    color: red;
} */

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted #40C782;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 200px;
  ;
  background-color: #fff;
  color: #808080;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  border: 1px solid #40C782;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>